import React, { useEffect, useState } from "react";

function CountAllDataS({ ...props }) {
    const [UData, setUData] = useState(0)
    const getdata = async () => {
        const sendData = {
            CatgTypeId: Number(props.catgTypeId)
        }
        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getcountofcat', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setUData(data)
                })


    };



    useEffect(() => {
        getdata()
    }, [props.catgTypeId])




    return (
        <>
            <td>{UData}</td>
            
        </>
    );
};

export default CountAllDataS;
